import React from 'react';

export const VideoPlaceholder = ({ horizontal }) => (
  <div className={`ct-placeholder ct-placeholder${horizontal ? '--horizontal' : '--vertical'}`}>
    <div className="thumbnail" />
    <div className="info">
      <div className="info__title" />
      <div className="info__metadata" />
    </div>
  </div>
);
